import { useMutation } from "@tanstack/react-query";
import { PageModuleStatus } from "entities/pages/types";
import { updateSettingModuleStatus } from "../api/updateSettingModuleStatus";
import { invalidateModuleListByBrandSettingQuery } from "../queries/useModuleListByBrandSettingQuery";

type Params = {
  moduleId: string;
  status: PageModuleStatus;
};

export const useUpdateSettingModuleStatusMutation = ({
  brandId,
  settingId,
}: {
  brandId: string;
  settingId: string;
}) => {
  return useMutation({
    mutationFn: async ({ moduleId, status }: Params) => {
      return await updateSettingModuleStatus({
        moduleId,
        status,
        brandId,
        settingId,
      });
    },
    onSuccess: () => {
      invalidateModuleListByBrandSettingQuery(brandId, settingId);
    },
    onError: (e) => {
      console.error("Error occurred when updating module", e);
    },
  });
};
